import { type CollaboratorDetails } from "@vega-api/generated/types/collaboratorDetails";

import { type useCollaboratorRolesManager } from "../../hooks/useCollaboratorRolesManager";

import { UserAssignmentSection } from "./UserAssignmentSection";

type EditAssignmentsStepProps = {
  collaborators: CollaboratorDetails[];
  manager: ReturnType<typeof useCollaboratorRolesManager>;
};

export const EditAssignmentsStep = ({
  collaborators,
  manager,
}: EditAssignmentsStepProps) => (
  <div
    className="flex flex-col gap-4 max-h-96 overflow-y-auto"
    data-testid="manage-roles-edit-step"
  >
    {collaborators.map((collaborator) => (
      <UserAssignmentSection
        collaborator={collaborator}
        hasFailed={manager.failedUserIds.has(collaborator.id)}
        key={collaborator.id}
        userState={manager.getUserState(collaborator.id)}
      />
    ))}
  </div>
);
